import { createContext, useState } from "react";

// Criando o contexto
const SearchContext = createContext();

// Criando o provider
export const SearchProvider = ({ children }) => {
  const [searchTerm, setSearchTerm] = useState(""); // 🔹 Estado da pesquisa

  return (
    <SearchContext.Provider value={{ searchTerm, setSearchTerm }}>
      {children}
    </SearchContext.Provider>
  );
};

export default SearchContext;
